import { useMemo } from 'react'

import { makeRequestURL, REACT_QUERY_KEYS, httpRequest } from 'common'
import { AxiosRequestConfig } from 'axios'
import { LANGUAGE_OPTIONS } from 'common/constants'
import { TEntity, TLanguage } from 'contexts/app-context/types'
import { Entities } from 'contexts/app-context/types/app-context/components/utils'

import { useQuery } from '@tanstack/react-query'

import { getPrivacyPolicyAcceptanceContentEndpoint } from '../utils'
import { IGetPrivacyPolicyAcceptanceContentResponse } from '../types'

export const useGetPrivacyPolicyAcceptanteContent = (org?: TEntity) => {
  const endpoint: AxiosRequestConfig = useMemo(() => {
    const selectedOrg = org && Entities.includes(org) ? org : 'US_BRANCH'

    const { language } = navigator

    const selectedLanguage = (LANGUAGE_OPTIONS.includes(language) ? language : 'pt-BR') as TLanguage

    const url = makeRequestURL(
      getPrivacyPolicyAcceptanceContentEndpoint.url ?? '',
      {
        entity: selectedOrg,
        language: selectedLanguage,
      },
      '.json',
    )

    return { ...getPrivacyPolicyAcceptanceContentEndpoint, url }
  }, [org])

  const {
    data,
    isError: isErrorContent,
    isLoading: isLoadingContent,
  } = useQuery({
    queryKey: [REACT_QUERY_KEYS.PRIVACY_POLICY_ACCEPTANCE_CONTENT],
    queryFn: () => httpRequest<IGetPrivacyPolicyAcceptanceContentResponse>(endpoint),
    staleTime: 1000 * 60 * 2, // 2 minutes
    gcTime: 1000 * 60 * 6, // 6 minutes
  })

  return {
    content: data?.content,
    endpoints: data?.endpoints,
    deeplinks: data?.deeplinks,
    isErrorContent,
    isLoadingContent,
  }
}
